<template>
  <section-page
    :title="'Partner Users (' + thirdPartyUsers.length + ')'"
    description="These are users that don't count to towards your user limit. These users allow the partner to login to your account and help you be successful."
    is-short
  >
    <app-loading-section
      :loading="false"
      :count="thirdPartyUsers.length"
      heading="There are no active users"
    >
      <table-default
        :table-data="thirdPartyUsers"
        default-sort="full_name"
      >
        <b-table-column label="Name" field="full_name" sortable v-slot="props">
          {{ props.row.full_name }}
          <span class="text-sub-label" v-if="props.row.is_owner">(Owner)</span>
        </b-table-column>

        <b-table-column label="Email Address" field="email_address" sortable v-slot="props">
          {{ props.row.email_address }}
        </b-table-column>

        <b-table-column label="Added On" field="created_at" sortable v-slot="props">
          {{ formatDate(props.row.created_at) }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="200" v-slot="props">
          <button-link @click="$refs.manageUserForm.open(props.row)">Manage</button-link>
        </b-table-column>
      </table-default>
    </app-loading-section>

    <modal-container>
      <modal-crud-form
        ref="manageUserForm"
        title="User"
        form-component="user-form"
        :hide-delete-button="true"
      ></modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "UsersThirdPartyUsers",
  computed: {
    thirdPartyUsers() {
      return this.$store.getters.thirdPartyUsers;
    },
  },
  methods: {
    formatDate(timestamp) {
      return dates.formatAsDate(timestamp);
    }
  },
}
</script>
